import * as types from '../../../actions'; 

const initialState = {
  skillRateAllItems: [],
  skillRateItem: [],
  skillRateCardAllItems: [],
  skillRateCardItem: [], 
  status:0,
  activity:'',
  chiefRateBonus: [],  
  rateCardChiefBonus: [],
  errorData: [],
  rateCardPageSubTitle: '',
};

export default function(state = initialState, action) {
    const response = action.response; 
    let timeVar = '~~'+Date.now(); 
    switch(action.type) {

        case types.SET_RATE_CARD_SUBTITLE: 
            return {
                ...state,
                rateCardPageSubTitle:action.data
            }

        case types.MASTER_RATE_CARD_LIST_AFFILIATE_SUCCESS:
            if(response.status===200){ 
                return {
                    ...state,
                    skillRateAllItems: response.data,
                    status: response.status,
                    activity: types.MASTER_RATE_CARD_LIST_AFFILIATE_SUCCESS+timeVar
                };
            }
            else {
                return {
                    ...state, 
                    status: response.status,
                    activity: types.MASTER_RATE_CARD_LIST_AFFILIATE_ERROR+timeVar, 
                    response 
                };   
            }    
        case types.MASTER_RATE_CARD_LIST_AFFILIATE_ERROR:
            return {
                ...state, 
                skillRateAllItems: response.data,
                status: response.status,
                activity: types.MASTER_RATE_CARD_LIST_AFFILIATE_ERROR+timeVar, 
                response 
            };  
 

        case types.MASTER_RATE_CARD_UPDATE_AFFILIATE_SUCCESS:
            if(response.status===200 && response.data.status==='success'){ 
                return {
                    ...state,
                    skillRateItem: response.data, 
                    status: response.data.status,
                    activity: types.MASTER_RATE_CARD_UPDATE_AFFILIATE_SUCCESS+timeVar
                };
            }
            else{
                return {
                    ...state, 
                    status: (response && response.status) ? response.status : '',
                    activity: types.MASTER_RATE_CARD_UPDATE_AFFILIATE_ERROR+timeVar, 
                    response 
                };   
            }
        case types.MASTER_RATE_CARD_UPDATE_AFFILIATE_ERROR:
            return {
                ...state, 
                status: (response && response.status) ? response.status : '',
                activity: types.MASTER_RATE_CARD_UPDATE_AFFILIATE_ERROR+timeVar, 
                response 
            };    
            
        case types.GET_AFFILIATE_CHEIF_BONUS_SUCCESS:
            if(response.status===200){ 
                return {
                    ...state,
                    chiefRateBonus: response.data, 
                    status: response.status,
                    activity: types.GET_AFFILIATE_CHEIF_BONUS_SUCCESS+timeVar
                };
            }
            else{
                return {
                    ...state, 
                    status: (response && response.status) ? response.status : '',
                    activity: types.GET_AFFILIATE_CHEIF_BONUS_ERROR+timeVar, 
                    errorData: (response && response.data) ? response.data : []  
                };   
            }
        case types.GET_AFFILIATE_CHEIF_BONUS_ERROR:
            return {
                ...state, 
                status: (response && response.status) ? response.status : '',
                activity: types.GET_AFFILIATE_CHEIF_BONUS_ERROR+timeVar, 
                errorData: (response && response.data) ? response.data : []  
            };    

        case types.UPDATE_AFFILIATE_CHEIF_BONUS_SUCCESS:
            if(response.status===200){ 
                return {
                    ...state,
                    chiefRateBonus: response.data, 
                    status: response.status,
                    activity: types.UPDATE_AFFILIATE_CHEIF_BONUS_SUCCESS+timeVar
                };
            }
            else{
                return { 
                    ...state, 
                    status: (response && response.status) ? response.status : '',
                    activity: types.UPDATE_AFFILIATE_CHEIF_BONUS_ERROR+timeVar, 
                    errorData: (response && response.data) ? response.data : [] 
                };   
            }
        case types.UPDATE_AFFILIATE_CHEIF_BONUS_ERROR:
            return {
                ...state, 
                status: (response && response.status) ? response.status : '',
                activity: types.UPDATE_AFFILIATE_CHEIF_BONUS_ERROR+timeVar, 
                errorData: (response && response.data) ? response.data : [] 
            };

        case types.RATECARD_CHEIF_BONUS_GET_SUCCESS:
            if(response.status===200){ 
                return {
                    ...state,
                    rateCardChiefBonus: response.data, 
                    status: response.status,
                    activity: types.RATECARD_CHEIF_BONUS_GET_SUCCESS+timeVar
                };
            }
            else{
                return {
                    ...state, 
                    status: (response && response.status) ? response.status : '',
                    activity: types.RATECARD_CHEIF_BONUS_GET_ERROR+timeVar, 
                    errorData: (response && response.data) ? response.data : []  
                };   
            }
        case types.RATECARD_CHEIF_BONUS_GET_ERROR:
            return {
                ...state, 
                status: (response && response.status) ? response.status : '',
                activity: types.RATECARD_CHEIF_BONUS_GET_ERROR+timeVar, 
                errorData: (response && response.data) ? response.data : []  
            }; 
        
        case types.RATECARD_CHEIF_BONUS_UPDATE_SUCCESS:
            if(response.status===200){ 
                return {
                    ...state,
                    rateCardChiefBonus: response.data, 
                    status: response.status,
                    activity: types.RATECARD_CHEIF_BONUS_UPDATE_SUCCESS+timeVar
                };
            }
            else{
                return { 
                    ...state, 
                    status: (response && response.status) ? response.status : '',
                    activity: types.RATECARD_CHEIF_BONUS_UPDATE_ERROR+timeVar, 
                    errorData: (response && response.data) ? response.data : [] 
                };   
            }
        case types.RATECARD_CHEIF_BONUS_UPDATE_ERROR:
            return {
                ...state, 
                status: (response && response.status) ? response.status : '',
                activity: types.RATECARD_CHEIF_BONUS_UPDATE_ERROR+timeVar, 
                errorData: (response && response.data) ? response.data : [] 
            }; 

        case types.COPY_MASTER_CARD_TO_CLIENT_SUCCESS:
            if(response.status===200){ 
                return {
                    ...state,
                    status: response.status,
                    activity: types.COPY_MASTER_CARD_TO_CLIENT_SUCCESS+timeVar
                };
            }
            else{
                return { 
                    ...state, 
                    status: (response && response.status) ? response.status : '',
                    activity: types.COPY_MASTER_CARD_TO_CLIENT_ERROR+timeVar, 
                    errorData: (response && response.data) ? response.data : [] 
                };   
            }
        case types.COPY_MASTER_CARD_TO_CLIENT_ERROR:
            return {
                ...state, 
                status: (response && response.status) ? response.status : '',
                activity: types.COPY_MASTER_CARD_TO_CLIENT_ERROR+timeVar, 
                errorData: (response && response.data) ? response.data : [] 
            };
        case types.COPY_CATEGORY_TO_CATEGORY_SUCCESS:
            if(response.status===200){ 
                return {
                    ...state,
                    status: response.status,
                    activity: types.COPY_CATEGORY_TO_CATEGORY_SUCCESS+timeVar
                };
            }
            else{
                return { 
                    ...state, 
                    status: (response && response.status) ? response.status : '',
                    activity: types.COPY_CATEGORY_TO_CATEGORY_ERROR+timeVar, 
                    errorData: (response && response.data) ? response.data : [] 
                };   
            }
        case types.COPY_CATEGORY_TO_CATEGORY_ERROR:
            return {
                ...state, 
                status: (response && response.status) ? response.status : '',
                activity: types.COPY_CATEGORY_TO_CATEGORY_ERROR+timeVar, 
                errorData: (response && response.data) ? response.data : [] 
            };    


        case types.RATE_CARD_LIST_SUCCESS:
            if(response.status===200){ 
                return {
                    ...state,
                    skillRateCardAllItems: response.data,
                    status: response.status,
                    activity: types.RATE_CARD_LIST_SUCCESS+timeVar
                };
            }
            else {
                return {
                    ...state, 
                    status: response.status,
                    activity: types.RATE_CARD_LIST_ERROR+timeVar, 
                    response 
                };   
            }    
        case types.RATE_CARD_LIST_ERROR:
            return {
                ...state, 
                skillRateCardAllItems: response.data, 
                status: response.status,
                activity: types.RATE_CARD_LIST_ERROR+timeVar, 
                response 
            };  


        case types.RATE_CARD_UPDATE_SUCCESS:
            if(response.status===200 && response.data.status==='success'){ 
                return {
                    ...state,
                    skillRateCardItem: response.data, 
                    status: response.data.status,
                    activity: types.RATE_CARD_UPDATE_SUCCESS+timeVar
                };
            }
            else{
                return {
                    ...state, 
                    status: (response && response.status) ? response.status : '',
                    activity: types.RATE_CARD_UPDATE_ERROR+timeVar, 
                    response 
                };   
            }
        case types.RATE_CARD_UPDATE_ERROR:
            return {
                ...state, 
                status: (response && response.status) ? response.status : '',
                activity: types.RATE_CARD_UPDATE_ERROR+timeVar, 
                response 
            };         

                










        
            
        case types.CLEAR:
            return {
                ...state, 
                activity:'',
                status:0               
            }  


        default:
            return state;
  }
};
